import customer_link from './customer_link.vue'
const CustomerLink = {
    install: function (Vue) {
        Vue.component('CustomerLink', customer_link)
    }
}
export default CustomerLink
